import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FEATURED_CATEGORIES } from "../data/menu";

export const FeaturedCategories = () => {
  const scrollToMenu = (catId) => {
    const el = document.getElementById(`menu-cat-${catId}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      document.getElementById("menu")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="categories"
      data-testid="featured-categories-section"
      className="relative bg-cream py-24 md:py-32 bean-bg"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="inline-flex items-center gap-3 text-espresso/60 text-[12px] tracking-[0.3em] uppercase mb-5">
              <span className="h-px w-10 bg-espresso/40" />
              Featured
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-espresso text-balance">
              Nine ways to <span className="italic">linger longer.</span>
            </h2>
          </div>
          <p className="max-w-sm text-soft/70 text-[14px] leading-[1.8]">
            Curated categories — each a small ritual in itself. Tap any card to
            jump to the full menu.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-espresso/15">
          {FEATURED_CATEGORIES.map((cat, i) => (
            <motion.button
              key={cat.id}
              onClick={() => scrollToMenu(cat.targetCategory)}
              data-testid={`category-card-${cat.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              className="group relative text-left bg-cream p-8 md:p-10 min-h-[260px] flex flex-col justify-between border-b border-r border-espresso/15 transition-colors duration-500 hover:bg-espresso"
            >
              <div className="flex items-start justify-between gap-6">
                <span className="font-script text-3xl text-gold group-hover:text-gold transition-colors duration-500">
                  0{i + 1}
                </span>
                <span className="shrink-0 w-10 h-10 rounded-full border border-espresso/30 flex items-center justify-center text-espresso group-hover:border-cream group-hover:text-cream transition-colors duration-500">
                  <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:rotate-45" />
                </span>
              </div>

              <div className="mt-10">
                <h3 className="font-serif text-3xl md:text-4xl leading-[1.05] text-espresso group-hover:text-cream transition-colors duration-500">
                  {cat.title}
                </h3>
                <p className="mt-3 text-[13px] text-soft/65 group-hover:text-cream/70 leading-[1.7] transition-colors duration-500">
                  {cat.description}
                </p>
              </div>

              {/* hover underline */}
              <span className="absolute bottom-0 left-0 h-[2px] bg-gold w-0 group-hover:w-full transition-all duration-700" />
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
